import { useAppSelector as useSelector } from 'dux/app/hooks';

import { legacyTheme, styled } from '@prose-ui/legacy';
import { FastField } from 'formik';

import { Checkbox } from 'Components/Checkbox';
import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';

import { pumpsOptOutCheckboxContent } from 'assets/content/checkout';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import * as checkoutCartSelectors from 'dux/checkoutCart/selectors';

const StyledCheckBoxDescription = styled(Typography)`
  ${legacyTheme.breakpoints.up('sm')} {
    max-width: 530px;
  }
`;

/**
 * Scenarios:
 * - First one-off order (without subscription): no pumps checkbox
 * - From n+1 one-off orders (without subscription): pumps checkbox with one-off label (endpoint cart_shipment_preference)
 * - For every subscription order: pumps checkbox with subscription label (endpoint customer_shipment_preference)
 */
const CartPumpsOption = () => {
  const cartHasSubscription = useSelector(checkoutCartSelectors.cartHasSubscription);
  const cartData = useSelector(checkoutCartSelectors.getCartData);
  const checkoutCategory = cartData.origin;

  const { isMobile } = useResponsiveVariant();

  const checkboxContent = cartHasSubscription
    ? pumpsOptOutCheckboxContent.withSubscription
    : pumpsOptOutCheckboxContent.oneOffOrder;

  return (
    <FastField name="wantsPumps">
      {({ field: { value }, form: { setFieldValue } }) => (
        <>
          <StyledCheckBoxDescription
            color="noirDark"
            inline={isMobile}
            variant={isMobile ? 'p3' : 'p2'}
          >
            {checkboxContent.description(checkoutCategory)}
          </StyledCheckBoxDescription>
          <Spacer size={12} />
          <Checkbox
            checked={value}
            dataTestId="pumps-opt-out-checkbox"
            id={checkboxContent.id}
            label={checkboxContent.ctaLabel(checkoutCategory)}
            labelColor="noirDark"
            labelVariant={isMobile ? 'p4' : 'p2'}
            name="wantsPumps"
            onChange={newValue => setFieldValue('wantsPumps', newValue.target.checked)}
            value={value}
          />
        </>
      )}
    </FastField>
  );
};

export default CartPumpsOption;
